module.exports = __webpack_public_path__ + "img/telegram.f79bafa8.svg";